import axios from 'axios';

export default {
  getDivision(params = {}) {
    return axios.get('/v1/list/division', { params });
  },
  getHouse(params = {}) {
    return axios.get('/v1/list/house', { params });
  },
  getDept(params = {}) {
    return axios.get('/v1/list/department', { params });
  },
  getBO(params = {}) {
    return axios.get('/v1/list/budget-owner', { params });
  },
  // dynamic
  getDiv(params = {}) {
    return axios.get('/v2/group/filter', { params });
  },
  getDetail(params = {}) {
    return axios.get('/v2/group/filter/detail', { params });
  }
};
